export default {
  embedded: {
    title: 'Konfetti: Safe Checkout',
    successTitle: 'Konfetti: Order confirmed!',
    newsletter:
      'Yes, I would like to be informed about trends, promotions & vouchers by email newsletter. Unsubscribe at any time. (optional)',
    userNotRegistered: 'Create your konfetti account',
    paymentMethods: 'Payment information',
    poweredBy: 'Powered by',
  },
}
